<template>
  <v-icon v-if="category" :color="forceColor ? forceColor : color" v-bind="$attrs">
    {{ icon }}
  </v-icon>
  <v-icon v-else v-bind="$attrs">{{ icon }}</v-icon>
</template>

<script>
export default {
  props: ['categoryName', 'category', 'forceColor'],
  data() {
    return {
      color: '',
      icon: 'mdi-label-outline',
    };
  },
  mounted() {
    if (this.category) {
      this.color = this.category.color;
      this.icon = this.category.icon;
    } else {
      switch (this.categoryName) {
        case 'contable':
          this.icon = 'mdi-circle-multiple-outline';
          break;
        case 'fiscal':
          this.icon = 'mdi-bank';

          break;
        case 'laboral':
          this.icon = 'mdi-account-group';

          break;
        case 'otros':
          this.icon = 'mdi-label-outline';

          break;

        default:
          this.icon = 'mdi-label-outline';

          break;
      }
    }
  },
};
</script>
